// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__ej8y1","imageAndText":"MessageSender_imageAndText__NbpVb","textarea":"MessageSender_textarea__pcNAy","button":"MessageSender_button__s+eCG"};